import { render } from "./FolderSettingsPopUp.vue?vue&type=template&id=296f16ad&scoped=true&ts=true"
import script from "./FolderSettingsPopUp.vue?vue&type=script&lang=ts"
export * from "./FolderSettingsPopUp.vue?vue&type=script&lang=ts"

import "./FolderSettingsPopUp.vue?vue&type=style&index=0&id=296f16ad&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296f16ad"]])

export default __exports__